import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { OrderPayload, isBudgetCodeValid, budgetCodeValidationModal } from 'pages/reference-implementation/provisioning/RI003AWS/store';
import ApplicationSection from 'pages/reference-implementation/provisioning/RI003AWS/components/sections/Application';
import AccessMgmtSection from 'pages/reference-implementation/provisioning/RI003AWS/components/sections/AccessMgmtSection';
import ResourceMgmtSection from 'pages/reference-implementation/provisioning/RI003AWS/components/sections/ResourceMgmtSection';
import BudgetCodeValidationModal from 'pages/provisioning/_components/StackProvisioning/Form/BudgetCodeValidationModal';

const IndexForm = () => {
    const [, setOrder] = useRecoilState(OrderPayload);
    const [, setBudgetCodeValid] = useRecoilState(isBudgetCodeValid);
    const [budgetCodeValidation, setBudgetCodeValidation] = useRecoilState(budgetCodeValidationModal);

    const closeBudgetCodeValidation = (isAccepted) => {
        if (isAccepted) setOrder((prev) => ({ ...prev, enabledManualBudgetCode: true }));
        setBudgetCodeValid(isAccepted);
        setBudgetCodeValidation({ open: false, budgetCode: '' });
    };
    return (
        <Box flex={3} data-testid="index-form">
            <ApplicationSection />
            <ResourceMgmtSection />
            <AccessMgmtSection />
            <BudgetCodeValidationModal
                open={budgetCodeValidation.open}
                budgetCode={budgetCodeValidation.budgetCode}
                onContinue={() => closeBudgetCodeValidation(true)}
                onCancel={() => closeBudgetCodeValidation(false)}
            />
        </Box>
    );
};

export default IndexForm;
